(function () {
  'use strict';

  var QUANTITY_SELECT_SELECTOR = 'select[name="options[Quantity]"], select[name="options[Quantity ]"]';
  var PACKAGING_SELECT_SELECTOR = 'select[name="options[Packaging]"]';
  var QTY_INPUT_SELECTOR = '.qty-input';
  var ARTWORK_UPLOAD_SELECTOR = '[data-52cards-artwork-upload]';
  var ARTWORK_HELPER_SELECTOR = '[data-52cards-artwork-helper]';

  var PACKAGING_HIDE_WHEN_QTY_1 = [
    'Cello-wrap (Included)',
    'White Window Tuck Box (+.25)'
  ];
  var PACKAGING_HIDE_WHEN_QTY_GT_1 = [
    'Smooth - White Window Tuck Box',
    'Linen - White Window Tuck Box'
  ];
  var SAMPLE_DECK_RE = /sample\s*deck/i;

  function shouldHidePackagingOption(optionValue, qty) {
    var value = String(optionValue || '').trim();

    if (qty === 1) {
      return PACKAGING_HIDE_WHEN_QTY_1.indexOf(value) !== -1;
    }

    return PACKAGING_HIDE_WHEN_QTY_GT_1.indexOf(value) !== -1;
  }

  function findSingleDeckOption(select) {
    if (!select) return null;

    var options = Array.prototype.slice.call(select.options || []);
    for (var i = 0; i < options.length; i += 1) {
      var option = options[i];
      var value = String(option.value || '').trim();
      var text = String(option.textContent || '').trim();
      if (value === '1' || text === '1' || /^1\s*deck/i.test(text)) {
        return option;
      }
    }

    return null;
  }

  // SAMPLE DECK variants only exist for quantity=1.
  // If a user picks SAMPLE DECK packaging, force quantity to 1 immediately.
  function forceSingleDeckForSamplePackaging() {
    var packagingSelect = document.querySelector(PACKAGING_SELECT_SELECTOR);
    if (!packagingSelect || !SAMPLE_DECK_RE.test(String(packagingSelect.value || ''))) {
      return false;
    }

    var quantitySelect = document.querySelector(QUANTITY_SELECT_SELECTOR);
    if (quantitySelect) {
      var singleDeckOption = findSingleDeckOption(quantitySelect);
      if (!singleDeckOption) return false;

      var singleDeckValue = String(singleDeckOption.value);
      if (String(quantitySelect.value) === singleDeckValue) {
        return false;
      }

      quantitySelect.value = singleDeckValue;
      quantitySelect.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    var quantityInput = document.querySelector(QTY_INPUT_SELECTOR);
    if (quantityInput && String(quantityInput.value) !== '1') {
      quantityInput.value = '1';
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  function readQuantity() {
    var sel = document.querySelector(QUANTITY_SELECT_SELECTOR);
    if (sel) {
      var n = parseInt(sel.value, 10);
      if (isFinite(n)) return n;
    }
    var input = document.querySelector(QTY_INPUT_SELECTOR);
    if (input) {
      var m = parseInt(input.value, 10);
      if (isFinite(m)) return m;
    }
    return null;
  }

  // Sync-phase: shift packaging's `selected` HTML attribute to a valid option BEFORE
  // Dawn's variant-selects change handler (in bubble phase) reads selectedOptionValues.
  // This lets Dawn's very first fetch target a real variant, avoiding the
  // null-variant -> setUnavailable -> "Unavailable" flash.
  // Does not remove options or dispatch change — that happens later in apply().
  function shiftPackagingSelectedFor(quantity) {
    var select = document.querySelector(PACKAGING_SELECT_SELECTOR);
    if (!select || quantity == null) return;

    var current = null;
    var fallback = null;
    Array.prototype.forEach.call(select.options, function (opt) {
      if ((opt.hasAttribute('selected') || opt.selected) && !current) current = opt;
      if (!shouldHidePackagingOption(opt.value, quantity) && !fallback) fallback = opt;
    });

    if (!current || !shouldHidePackagingOption(current.value, quantity)) return;
    if (!fallback || fallback === current) return;

    current.removeAttribute('selected');
    fallback.setAttribute('selected', 'selected');
    select.value = fallback.value;
  }

  function applyPackagingRule(quantity) {
    var select = document.querySelector(PACKAGING_SELECT_SELECTOR);
    if (!select || quantity == null) return;

    var hadToFallback = false;
    Array.prototype.slice.call(select.options).forEach(function (opt) {
      if (shouldHidePackagingOption(opt.value, quantity)) {
        if (opt.hasAttribute('selected') || opt.selected) hadToFallback = true;
        opt.parentNode.removeChild(opt);
      }
    });

    if (hadToFallback && select.options.length > 0) {
      // Dawn's updateSelectionMetadata throws if no remaining option has the `selected`
      // HTML attribute, so re-establish it on the fallback before dispatching change.
      Array.prototype.forEach.call(select.options, function (opt) {
        opt.removeAttribute('selected');
      });
      select.options[0].setAttribute('selected', 'selected');
      select.selectedIndex = 0;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function applyArtworkRule(quantity) {
    var nodes = document.querySelectorAll(
      ARTWORK_UPLOAD_SELECTOR + ',' + ARTWORK_HELPER_SELECTOR
    );
    Array.prototype.forEach.call(nodes, function (el) {
      if (quantity === 1) {
        el.setAttribute('hidden', '');
      } else {
        el.removeAttribute('hidden');
      }
    });
  }

  var applyScheduled = false;
  function apply() {
    var q = readQuantity();
    applyPackagingRule(q);
    applyArtworkRule(q);
  }
  function scheduleApply() {
    if (applyScheduled) return;
    applyScheduled = true;
    (window.requestAnimationFrame || function (cb) { setTimeout(cb, 16); })(function () {
      applyScheduled = false;
      apply();
    });
  }

  function onChangeCapture(e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches(QUANTITY_SELECT_SELECTOR)) {
      var n = parseInt(t.value, 10);
      shiftPackagingSelectedFor(isFinite(n) ? n : null);
      scheduleApply();
      return;
    }
    if (t.matches(PACKAGING_SELECT_SELECTOR)) {
      if (forceSingleDeckForSamplePackaging()) return;
      scheduleApply();
      return;
    }
    if (t.matches(QTY_INPUT_SELECTOR)) {
      scheduleApply();
    }
  }

  function subscribeToVariantChange() {
    if (typeof window.subscribe !== 'function' || typeof window.PUB_SUB_EVENTS === 'undefined') {
      return false;
    }
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
      scheduleApply();
    });
    return true;
  }

  function observeProductInfo() {
    var productInfo = document.querySelector('product-info');
    if (!productInfo || typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function () {
      scheduleApply();
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function init() {
    apply();

    document.addEventListener('change', onChangeCapture, true);
    document.addEventListener('input', onChangeCapture, true);

    if (!subscribeToVariantChange()) {
      var retries = 0;
      var retryId = setInterval(function () {
        if (subscribeToVariantChange() || ++retries > 20) clearInterval(retryId);
      }, 100);
    }

    observeProductInfo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();